const route = {
	path: 'reports',
	name: '/reports',
	redirect: '/general',
	component: () => import('@/components/reports/reports'),
	children: [
		{
			name: 'general-reports',
			path: '/general',
			meta: {
				title: 'Reportes Generales',
			},
			component: () => import('@/pages/reports/general-reports'),
		},
	],
};

export default route;



// WEBPACK FOOTER //
// ./src/router/reports.js